import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import { TkBankSelectionContext } from "../../context";
import TkFakeTableLine from "../../../../atoms/TkFakeTableLine";
import TkButton from "../../../../atoms/TkButton";
import { IConfirmationTableProps } from "../../../../../type/componentsType/TkBankSelection";
import "./_style.scss";

/**
 * 確認テーブルコンポーネント
 *
 * @param {IConfirmationTableProps} props - コンポーネントのプロパティ
 * @returns {React.FC} - 確認テーブルコンポーネント
 */
const ConfirmationTable: React.FC<IConfirmationTableProps> = (props) => {
  const { onSuccessful } = props;

  const [comfirmBank, setComfirmBank] = React.useState<any>({});
  const { state, setState } = useContext(TkBankSelectionContext);

  useEffect(() => {
    const { bankCode, bankName, bankNameKatakana, branchCode, branchName, branchNameKatakana } =
      state;

    const bank = {
      "金融機関コード": bankCode,
      "金融機関名（漢字）": bankName,
      "金融機関名(ｶﾅ)": bankNameKatakana,
      "支店コード": branchCode,
      "支店名（漢字）": branchName,
      "支店名(ｶﾅ)": branchNameKatakana,
    };

    setComfirmBank(bank);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="ConfirmationTable">
      {comfirmBank &&
        Object.entries(comfirmBank).map(([key, value], index) => {
          return (
            <TkFakeTableLine
              key={index}
              type="text"
              text={value}
              title={key}
            ></TkFakeTableLine>
          );
        })}

      <Box className="moveButton">
        <TkButton
          size="large"
          onClick={() => {
            setState({
              ...state,
              step: 1,
            });
          }}
        >
          戻る
        </TkButton>
        <TkButton
          onClick={() => {
            onSuccessful(state);
            setState({ ...state });
          }}
          size="large"
          ml
        >
          確定
        </TkButton>
      </Box>
    </Box>
  );
};

export default ConfirmationTable;
